import {
  ERROR_ENUM,
  CANCELED_ENUM,
  PARTIAL_VOID_ENUM,
  REFUNDED_ENUM,
  PARTIAL_REFUNDED_ENUM,
  CREATED_ENUM,
  CAPTURED_ENUM,
  AUTORIZED_PENDING_CAPTURE_ENUM,
  NOT_AUTORIZED_ENUM,
  FAILED_ENUM,
  PAID_ENUM,
  GENERATED_ENUM,
  PARTIAL_CAPTURED_ENUM,
  OVERPAID_ENUM,
  UNDERPAID_ENUM,
  PARTIAL_WAITING_REFUND_ENUM,
  PAYMENT_PEDDING_ENUM,
  ERROR_ON_VOID,
  PENDING_AUTHENTICATION
} from '@enums/status-transaction.enum'

const FORMAT_VALUE = args => {
  return {
    description: args?.description ?? '',
    color: args?.color ?? 'info',
    ...args
  }
}

const FORMAT_BY_STATUS_REPROVED = args => {
  return {
    description:
      args?.anti_fraud?.status === 'reproved' ? 'value-reproved' : '',
    color: args?.color ?? 'negative',
    ...args
  }
}

// status enums

const STATUS_AUTORIZED_PENDING_CAPTURE = {
  status: AUTORIZED_PENDING_CAPTURE_ENUM.list(),
  format: args => ({
    description: 'value-capture-pending',
    color: 'info',
    ...args
  })
}

const STATUS_NOT_AUTORIZED = {
  status: NOT_AUTORIZED_ENUM.list(),
  format: args => FORMAT_BY_STATUS_REPROVED(args)
}

const STATUS_PAYMENT_PEDDING = {
  status: PAYMENT_PEDDING_ENUM.list(),
  format: args => ({
    color: 'warning',
    ...args
  })
}

const STATUS_FAILED = {
  status: FAILED_ENUM.list(),
  format: args => ({
    color: 'negative',
    ...args
  })
}

const STATUS_PAID = {
  status: PAID_ENUM.list(),
  format: args => ({
    color: 'positive',
    ...args
  })
}

const STATUS_GENERATED = {
  status: GENERATED_ENUM.list(),
  format: args => ({
    color: 'positive',
    ...args
  })
}

const STATUS_PARTIAL_CAPTURED = {
  status: PARTIAL_CAPTURED_ENUM.list(),
  format: args => FORMAT_VALUE({ description: 'value-captured', ...args })
}

const STATUS_CAPTURED = {
  status: CAPTURED_ENUM.list(),
  format: args => FORMAT_VALUE({ description: 'value-captured', ...args })
}

const STATUS_PARTIAL_REFUNDED = {
  status: PARTIAL_REFUNDED_ENUM.list(),
  format: args =>
    FORMAT_VALUE({ color: 'warning', description: 'value-refunded', ...args })
}

const STATUS_REFUNDED = {
  status: REFUNDED_ENUM.list(),
  format: args =>
    FORMAT_VALUE({ color: 'negative', description: 'value-refunded', ...args })
}

const STATUS_PARTIAL_CANCELED = {
  status: PARTIAL_VOID_ENUM.list(),
  format: args =>
    FORMAT_VALUE({ color: 'warning', description: 'value-canceled', ...args })
}

const STATUS_CANCELED = {
  status: CANCELED_ENUM.list(),
  format: args => FORMAT_BY_STATUS_REPROVED(args)
}

const STATUS_ERROR = {
  status: ERROR_ENUM.list(),
  format: args => FORMAT_VALUE({ color: 'negative', ...args })
}

const STATUS_CREATED = {
  status: CREATED_ENUM.list(),
  format: args => FORMAT_VALUE(args)
}

const STATUS_OVERPAID = {
  status: OVERPAID_ENUM.list(),
  format: args => ({
    color: 'positive',
    description: 'value-paid',
    ...args
  })
}

const STATUS_UNDERPAID = {
  status: UNDERPAID_ENUM.list(),
  format: args => ({
    color: 'positive',
    description: 'value-paid',
    ...args
  })
}

const STATUS_PARTIAL_WAITING_REFUND = {
  status: PARTIAL_WAITING_REFUND_ENUM.list(),
  format: args =>
    FORMAT_VALUE({ color: 'warning', description: 'value-refund', ...args })
}

const STATUS_ERROR_ON_VOID = {
  status: ERROR_ON_VOID.list(),
  format: args => FORMAT_VALUE({ color: 'negative', ...args })
}

const STATUS_PENDING_AUTHENTICATION = {
  status: PENDING_AUTHENTICATION.list(),
  format: args => FORMAT_VALUE({ color: 'warning', ...args })
}

export const STATUS_TRANSACTION_ENUM = {
  STATUS_AUTORIZED_PENDING_CAPTURE,
  STATUS_CAPTURED,
  STATUS_NOT_AUTORIZED,
  STATUS_PAYMENT_PEDDING,
  STATUS_FAILED,
  STATUS_PAID,
  STATUS_GENERATED,
  STATUS_PARTIAL_CAPTURED,
  STATUS_PARTIAL_REFUNDED,
  STATUS_REFUNDED,
  STATUS_PARTIAL_CANCELED,
  STATUS_CANCELED,
  STATUS_ERROR,
  STATUS_CREATED,
  STATUS_OVERPAID,
  STATUS_UNDERPAID,
  STATUS_PARTIAL_WAITING_REFUND,
  STATUS_ERROR_ON_VOID,
  STATUS_PENDING_AUTHENTICATION
}

export const getStatus = statusName => {
  if (!statusName) throw new Error('Missing statusName!')
  return Object.values(STATUS_TRANSACTION_ENUM).find(({ status }) =>
    status.map(item => item?.toLowerCase()).includes(statusName?.toLowerCase())
  )
}
